import styled, { css } from "styled-components";

interface PropsButton {
  status: string;
  border?: boolean;
  icon?: boolean;
}

const normalizeStatus = (status: string) =>
  (status || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const getStatusBackground = (status: string) => {
  const normalizedStatus = normalizeStatus(status);

  if (normalizedStatus === "pendente") return "#9D54BB";
  if (normalizedStatus === "concluido") return "#51C4AF";
  if (normalizedStatus === "cancelado") return "#D9538D";
  if (normalizedStatus === "visualizar") return "#5178C4";
  if (normalizedStatus === "em_producao" || normalizedStatus === "em producao") {
    return "#F2A33B";
  }

  return "#6f7782";
};

export const Container = styled.button<PropsButton>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  height: 40px;
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
  text-transform: capitalize;
  color: #fff;
  border: none;
  padding: 10px 40px;
  transition: filter 0.3s;
  cursor: pointer;
  &:hover {
    filter: brightness(0.9);
  }

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
    background: #cecece;
  }

  ${props => props.border && css`
    border-radius: 25px;
  `}

  background: ${props => getStatusBackground(props.status)};

 .hasIcon {
   display: grid;
   place-items: center;
   margin-right: 12px;
 }

`;
